import './donate.css';
import React from 'react';
import parse from 'html-react-parser';
import { Button } from '@mui/material';

export default function MakingDonations({ currentActive, setNextStep }) {

    const steps = [
        {
            text: "Make a transfer to <b>Hoh Chee Kin</b> at <b>114815105786</b> via <b>MayBank</b>.",
        },
        {
            text: "Take a picture/screenshot of the transaction.",
        },
    ];

    return (
        <div className="card w-100 my-3">
            <div className="card-body">
                <h3 className="card-title">
                    How To Donate
                </h3>
                {
                    steps.map((x, i) => {
                        return (
                            <div key={i} className="d-flex flex-row">
                                <p className='donations-list'>{i + 1}</p>
                                <p className="ms-2 w-100">
                                    {
                                        parse(x.text)
                                    }
                                </p>
                            </div>
                        );
                    })
                }
                <h3>International Donations</h3>
                <p>
                    For international donations, please donate to <b>Justin Leong Han Wen</b> at&nbsp;
                    <a href="justinleong04@gmail.com">justinleong04@gmail.com</a> via
                    Paypal.
                </p>
                <Button variant="contained" disableElevation onClick={() => setNextStep(currentActive + 1)}>Next</Button>
            </div>
        </div>
    )
}
